import React from 'react';
import LoadingMessageContainer from './LoadingMessageContainer';

const AppLoading = () => <LoadingMessageContainer />;

export default AppLoading;
